import React from "react";

const InfoBlock: React.FC<{ icon: React.ReactNode; label: string; value: React.ReactNode; fullWidth?: boolean }> = ({icon, label, value, fullWidth}) => (
    <div className={`flex flex-col gap-1.5 p-4 bg-white dark:bg-neutral-900 ${fullWidth ? 'col-span-2' : ''}`}>
        <div className="flex items-center gap-1.5">
            <div className="w-4 h-4 flex-shrink-0">{icon}</div>
            <span className="text-xs text-neutral-500 dark:text-neutral-400">{label}</span>
        </div>
        <div className="text-sm font-semibold text-neutral-900 dark:text-neutral-100 pl-[22px]">{value}</div>
    </div>
);

export default InfoBlock;
